import _ from 'lodash'

MachineDetailController.$inject = ['userProfile']
function MachineDetailController(userProfile) {
  var vm = this

  vm.hasPermission = hasPermission
  vm.$onInit = () => {
    vm.currentConfiguration = _.find(vm.machineHistory.MachineChanges, function (change) { return change.MachineConfiguration.CurrentConfiguration })
  }

  function hasPermission(permission) {
    return userProfile.hasPermission(permission)
  }

}

export default MachineDetailController
